var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{style:(`height: ${this.height}px`),attrs:{"flat":""}},[_c(_vm.data.component,{tag:"component",attrs:{"data":_vm.getData,"mode":_vm.getMode,"parentActions":_vm.getActions},on:{"close":(payload) => {_vm.$emit('close', payload)},"edit":(payload) => {_vm.$emit('edit', payload)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }